import { render, staticRenderFns } from "./ProductBundleDetails.vue?vue&type=template&id=0fdd36fd&scoped=true&"
import script from "./ProductBundleDetails.vue?vue&type=script&lang=js&"
export * from "./ProductBundleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd36fd",
  null
  
)

export default component.exports